"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleKeyBinding = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("@draft-js-plugins/mention/lib/plugin.css");
var anchor_1 = __importDefault(require("@draft-js-plugins/anchor"));
var buttons_1 = require("@draft-js-plugins/buttons");
var editor_1 = __importDefault(require("@draft-js-plugins/editor"));
var inline_toolbar_1 = __importDefault(require("@draft-js-plugins/inline-toolbar"));
var mention_1 = __importDefault(require("@draft-js-plugins/mention"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var draft_js_1 = require("draft-js");
var firestore_1 = require("firebase/firestore");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var ProfileAvatar_1 = __importDefault(require("atomicComponents/molecules/Image/ProfileAvatar"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var selectors_1 = require("containers/Settings/Users/selectors");
var hooks_2 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var EditorWrapper_1 = __importDefault(require("./EditorWrapper"));
var MentionLink_1 = __importDefault(require("./MentionLink"));
var Mentions_1 = __importDefault(require("./Mentions"));
var utils_1 = require("./utils");
var TransparentOverlay = (0, styles_1.styled)(material_1.Backdrop)(function () { return ({ backgroundColor: 'rgba(0,0,0,0)' }); });
var handleKeyBinding = function (e) {
    if (e.key === 'Enter' && e.shiftKey) {
        return 'split-block';
    }
    if (e.key === 'Enter') {
        return 'myeditor-enter';
    }
    if (e.ctrlKey && e.key === 'k') {
        return 'add-link';
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        return null;
    }
    return (0, draft_js_1.getDefaultKeyBinding)(e);
};
exports.handleKeyBinding = handleKeyBinding;
var linkPlugin = (0, anchor_1.default)({
    theme: {
        link: 'draftjs-linkplugin-link',
        input: 'draftjs-linkplugin-input',
        inputInvalid: 'draftjs-linkplugin-inputInvalid',
    },
    placeholder: 'https://',
    linkTarget: '_blank',
});
var styleMap = {
    BOLD: {
        fontWeight: 600,
    },
};
var CommentEditor = function (_a) {
    var _b;
    var serviceId = _a.serviceId, comment = _a.comment, readOnly = _a.readOnly, closeEditMode = _a.closeEditMode;
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var myProfile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var ref = react_1.default.useRef(null);
    var _c = __read(react_1.default.useState(function () { return draft_js_1.EditorState.createEmpty(); }), 2), editorState = _c[0], setEditorState = _c[1];
    var confirm = (0, hooks_1.useConfirm)();
    var _d = __read((0, hooks_2.useSubmitter)('comments', comment === null || comment === void 0 ? void 0 : comment.id), 2), commentSubmitter = _d[0], isSubmitting = _d[1];
    var activeUsers = (0, react_redux_1.useSelector)(selectors_1.selectPopulatedActiveUsers);
    var allServices = (0, react_redux_1.useSelector)(ordered_1.selectServices);
    var services = (0, react_1.useMemo)(function () { return allServices === null || allServices === void 0 ? void 0 : allServices.filter(function (s) { return s.niceName || s.name; }).map(utils_1.getMentionDataForService); }, [allServices]);
    var publicUsers = (0, react_1.useMemo)(function () { return activeUsers === null || activeUsers === void 0 ? void 0 : activeUsers.filter(function (u) { return u.displayName || u.firstName; }).map(utils_1.getMentionDataForUser); }, [activeUsers]);
    var _e = react_1.default.useMemo(function () {
        var inlineToolbarPlugin = (0, inline_toolbar_1.default)({
            theme: {
                buttonStyles: {
                    active: 'draftjs-inlinetoolbar-button-active',
                    button: 'draftjs-inlinetoolbar-button',
                    buttonWrapper: 'draftjs-inlinetoolbar-button-wrapper',
                },
                toolbarStyles: {
                    toolbar: 'draftjs-inlinetoolbar-toolbar',
                },
            },
        });
        var mentionPlugin = (0, mention_1.default)({
            mentionPrefix: '@',
            mentionComponent: MentionLink_1.default,
            supportWhitespace: true,
        });
        return {
            plugins: [mentionPlugin, inlineToolbarPlugin, linkPlugin],
            MentionSuggestions: mentionPlugin.MentionSuggestions,
            InlineToolbar: inlineToolbarPlugin.InlineToolbar,
            LinkPlugin: linkPlugin.LinkButton,
        };
    }, []), MentionSuggestions = _e.MentionSuggestions, InlineToolbar = _e.InlineToolbar, plugins = _e.plugins;
    var _f = __read(react_1.default.useState(null), 2), remountKey = _f[0], setRemountKey = _f[1];
    (0, react_1.useEffect)(function () { var _a; return !readOnly ? (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus() : undefined; }, [readOnly]);
    (0, react_1.useEffect)(function () { return editorState && !editorState.getDecorator() ? setRemountKey((remountKey || 0) + 1) : undefined; }, [editorState]);
    (0, react_1.useEffect)(function () { return comment ? setEditorState(draft_js_1.EditorState.createWithContent((0, draft_js_1.convertFromRaw)(comment.comment))) : undefined; }, [(_b = comment === null || comment === void 0 ? void 0 : comment.updatedAt) === null || _b === void 0 ? void 0 : _b.toMillis()]);
    var handleKeyCommand = function (command) {
        if (command === 'myeditor-enter' && editorState.getCurrentContent().hasText()) {
            var oldEditorState_1 = editorState;
            var rawCommentState = (0, draft_js_1.convertToRaw)(editorState.getCurrentContent());
            if (!comment) {
                setEditorState(draft_js_1.EditorState.createEmpty());
            }
            commentSubmitter({
                userId: myProfile === null || myProfile === void 0 ? void 0 : myProfile.id,
                companyId: myCompany === null || myCompany === void 0 ? void 0 : myCompany.id,
                serviceId: serviceId,
                comment: rawCommentState,
                createdAt: comment ? undefined : firestore_1.Timestamp.now(),
                updatedAt: firestore_1.Timestamp.now(),
            }).then(function () {
                if (closeEditMode)
                    closeEditMode();
            }).catch(function () {
                setEditorState(oldEditorState_1);
            });
            return 'handled';
        }
        // ToDo: evaluate using RichUtils.handleKeyCommand(editorState, command) directly without checking for the command
        // (it might return null when it can't do anything with the command)
        if (['bold', 'underline', 'italic', 'strikethrough', 'code'].includes(command)) {
            setEditorState(draft_js_1.RichUtils.handleKeyCommand(editorState, command) || editorState);
            return 'handled';
        }
        return 'not-handled';
    };
    var onClickOverlay = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isDiscard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!closeEditMode)
                        return [2 /*return*/];
                    if (!!(0, isEqual_1.default)(comment === null || comment === void 0 ? void 0 : comment.comment, (0, draft_js_1.convertToRaw)(editorState.getCurrentContent()))) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirm('Do you want to discard your changes?', '', 'red', 'Discard')];
                case 1:
                    isDiscard = _a.sent();
                    if (isDiscard) {
                        if (comment === null || comment === void 0 ? void 0 : comment.comment) {
                            setEditorState(draft_js_1.EditorState.createWithContent((0, draft_js_1.convertFromRaw)(comment === null || comment === void 0 ? void 0 : comment.comment)));
                        }
                        closeEditMode();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    closeEditMode();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [comment && !readOnly && ((0, jsx_runtime_1.jsx)(TransparentOverlay, { open: true, onClick: onClickOverlay, sx: { zIndex: function (theme) { return theme.zIndex.drawer + 1; } } })), (0, jsx_runtime_1.jsxs)(EditorWrapper_1.default, __assign({ onClick: function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, readOnly: readOnly || true, isEdit: !!comment }, { children: [editorState && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!readOnly && !comment && ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 0.25 }, { children: (0, jsx_runtime_1.jsx)(ProfileAvatar_1.default, { profile: myProfile }) }))), (0, jsx_runtime_1.jsx)(editor_1.default, { customStyleMap: styleMap, editorKey: comment ? "edit-comment-".concat(comment.id) : 'editor', editorState: editorState, onChange: setEditorState, keyBindingFn: exports.handleKeyBinding, handleKeyCommand: handleKeyCommand, plugins: plugins, ref: ref, placeholder: "Add a comment", readOnly: readOnly || isSubmitting }, remountKey)] })), (0, jsx_runtime_1.jsx)(InlineToolbar, { children: function (externalProps) { return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(buttons_1.BoldButton, __assign({}, externalProps)), (0, jsx_runtime_1.jsx)(buttons_1.ItalicButton, __assign({}, externalProps)), (0, jsx_runtime_1.jsx)(buttons_1.UnderlineButton, __assign({}, externalProps)), (0, jsx_runtime_1.jsx)(buttons_1.CodeBlockButton, __assign({}, externalProps)), (0, jsx_runtime_1.jsx)(linkPlugin.LinkButton, __assign({}, externalProps))] })); } }), publicUsers && services && (0, jsx_runtime_1.jsx)(Mentions_1.default, { MentionSuggestions: MentionSuggestions, users: publicUsers, services: services })] }))] }));
};
exports.default = CommentEditor;
